export const getBottomDrawerAnimation = (expires: boolean) => ({
    from: { bottom: "-100%" },
    enter: { bottom: "0%" },
    leave: { bottom: "-100%" },
    expires,
});